import { combineReducers } from 'redux';
import ListReducer from './List/ListReducer';
import SnackbarReducer from './UI/SnackbarReducer';

const RootReducer = combineReducers({
  list: ListReducer,
  snackbar: SnackbarReducer,
});

export default RootReducer;
